/**
 * 🔒 A page asks the header's global search for a term (decision 1477): the mail
 * client's Find across the application puts the sender's address in the field
 * and opens its results, the same search a person types. The header is the
 * search's one owner, so a page names the term and never draws a second search.
 */
export const GLOBAL_SEARCH_ASK_EVENT = 'bms2:global-search-ask';

export function askGlobalSearch(term: string): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(GLOBAL_SEARCH_ASK_EVENT, { detail: { term } }));
}
